<template>
  <span>
    <router-link to="/pricing/configuration" v-if="userHasReadPermission(PermissionTypes.PricingPermissionTypes.pricingConfig)" :target="target" :class="{'router-link-newtab': newTab}">
      {{name}}
    </router-link>
    <span v-else>
      {{name}}
    </span>
  </span>
</template>

<script>
export default {
  name: 'LinkStockPriceGroup',
  props: {
    id: Number,
    name: String,
    newTab: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    target() {
      if(this.newTab)
        return '_blank'

      return '_self'
    }
  }
}
</script>
